var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.179,
    height: 19.181,
    viewBox: "0 0 19.179 19.181",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#dfd8d0;}.b{fill:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(12 12.001)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-12 -12.001)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M14.988,5.593l-3-3L4,10.588v3H7Zm2.365-2.365a.8.8,0,0,0,0-1.127L15.484.231a.8.8,0,0,0-1.127,0L12.791,1.8l3,3Z",
    transform: "translate(-0.803 0.002)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M0,0H19.179V19.179H0Z",
    transform: "translate(0 0.002)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.2d8ee6d002749454b24ddf5154ddae72.svg";
export { ForwardRef as ReactComponent };